var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSushiswapLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7623 9.05664L94.1623 59.8566L75.7623 87.0566L1.3623 35.8566L19.7623 9.05664Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1621 59.8564C87.7621 69.0564 66.162 65.4564 45.762 51.0564C24.962 37.0564 13.762 18.2563 19.762 9.05635C26.162 -0.143654 47.762 3.45635 68.162 17.8563C88.9621 31.4564 100.162 50.6564 94.1621 59.8564Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7622 86.6567C69.3622 95.8568 47.7622 92.2567 27.3622 77.8567C6.96224 63.4567 -4.63776 45.0567 1.76224 35.4567C8.16224 26.2567 29.7622 29.8567 50.1622 44.2567C70.5622 58.6567 81.7622 77.4567 75.7622 86.6567Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1621 59.8563L75.7621 87.0563C69.3621 96.2563 47.7621 92.2563 27.3621 78.2563C23.3621 75.4563 19.7621 72.6563 16.1621 69.4563C18.9621 69.0563 22.5621 67.4563 26.1621 63.4563C32.5621 56.6563 35.7621 55.0563 38.5621 55.4563C41.3621 55.4563 44.5621 58.2563 49.7621 65.0563C54.9621 71.8563 62.1621 73.8563 66.5621 70.2563C66.9621 69.8563 67.3621 69.8563 67.7621 69.4563C71.3621 66.6563 72.5621 65.4563 79.3621 52.6563C80.9621 49.4563 86.5621 44.2563 94.1621 46.6563C96.1621 51.8563 96.1621 56.2563 94.1621 59.8563Z",
    fill: "#0E0F23"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.3618 58.2556C85.7618 66.2556 66.1618 62.2556 47.3618 49.0556C28.1618 35.8556 16.9618 19.0556 22.5618 11.0556C28.1618 3.05558 47.7618 7.05558 66.5618 20.2556C85.3618 33.4556 96.5618 50.2556 91.3618 58.2556ZM73.7618 46.2556C70.9618 50.2556 61.3618 48.2556 51.7618 41.8556C42.5618 35.4556 36.9618 27.0556 39.7618 23.0556C42.5618 19.0556 52.1618 21.0556 61.7618 27.4556C70.9618 33.8556 76.5618 42.2556 73.7618 46.2556Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1625 18.2571C18.1625 17.8571 17.7625 17.4571 17.3625 17.8571C16.9625 18.2571 16.5625 18.2571 16.5625 18.6571C16.9625 19.8571 17.3625 20.6571 17.3625 21.4571C17.3625 21.8571 17.7625 22.2571 18.1625 21.8571C18.5625 21.8571 18.9625 21.4571 18.5625 21.0571C18.5625 20.2571 18.5625 19.4571 18.1625 18.2571Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1619 24.6555C20.1619 24.2555 19.7619 23.8555 19.3619 24.2555C18.9619 24.6555 18.9619 24.6555 18.9619 25.0555C23.3619 35.0555 32.5619 45.8555 44.5619 53.8555C44.9619 54.2555 45.3619 53.8555 45.7619 53.8555C46.1619 53.4555 45.7619 53.0555 45.7619 52.6555C33.3619 44.6555 24.5619 34.2555 20.1619 24.6555Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5627 63.8555C68.1627 63.8555 67.7627 63.8555 67.7627 64.2555C67.7627 64.6555 67.7627 65.0555 68.1627 65.0555C69.3627 65.4555 70.9627 65.8555 72.1627 66.2555C72.5627 66.2555 72.9627 66.2555 72.9627 65.8555C72.9627 65.4555 72.9627 65.0555 72.5627 65.0555C71.3627 64.6555 69.7627 64.2555 68.5627 63.8555Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7619 65.457C75.3619 65.457 74.9619 65.857 74.9619 66.257C74.9619 66.657 75.3619 67.057 75.7619 67.057C78.9619 67.457 82.5619 67.857 85.3619 67.457C85.7619 67.457 86.1619 67.057 86.1619 66.657C86.1619 66.257 85.7619 65.857 85.3619 65.857C82.1619 66.257 78.9619 65.857 75.7619 65.457Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 34.3391,
    y1: 1.83384,
    x2: 49.0935,
    y2: 52.4986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA52A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 46.4892,
    y1: -1.70526,
    x2: 61.244,
    y2: 48.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA52A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 22.2262,
    y1: 5.36113,
    x2: 36.981,
    y2: 56.0263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA52A0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSushiswapLogo);
export default __webpack_public_path__ + "static/media/sushiswap-logo.050d016ca9902ba7547090e95690e1c1.svg";
export { ForwardRef as ReactComponent };